import gql from 'graphql-tag';
import { dynamoProductFragments } from '../fragments';

const dynamoProductQueries = {
  DynamoProductSearch: gql`
    query (
      $orderBy: String!
      $orderByDirection: String!
      $locale: LocaleInput!
      $tags: [[String]]
      $pagination: CatalogPaginationInput
    ) {
      dynamoProductSearch (
        orderBy: $orderBy
        orderByDirection: $orderByDirection
        locale: $locale
        tags: $tags
        pagination: $pagination
      ) {
        paginationKey
        products {
          description
          ...ListProduct
        }
      }
    }
    ${dynamoProductFragments.listProduct}
  `,
  DynamoPromotedProducts: gql`
    query (
      $locale: LocaleInput!
    ) {
      dynamoPromotedProducts (
        locale: $locale
      ) {
        products {
          ...ListProduct
        }
      }
    }
    ${dynamoProductFragments.listProduct}
  `,
  DynamoProductById: gql`
    query (
      $id: Int!,
      $language: LanguageEnum,
      $currency: CurrencyEnum
    ) {
      dynamoProductById (
        id: $id
        locale: {
          language: $language
          currency: $currency
        }
      ) {
        ...FullProduct
      }
    }
    ${dynamoProductFragments.fullProduct}
  `,
  DynamoProductByLinkId: gql`
    query (
      $id: String!,
      $language: LanguageEnum,
      $currency: CurrencyEnum
    ) {
      dynamoProductByLinkId (
        linkId: $id
        locale: {
          language: $language
          currency: $currency
        }
      ) {
        ...FullProduct
      }
    }
    ${dynamoProductFragments.fullProduct}
  `
};

export default dynamoProductQueries;
